module.exports = __webpack_public_path__ + "img/awkward_ios_802.png";